export default num => num && Number(num).toLocaleString();
